import { Action, createReducer, on } from '@ngrx/store';
import { EntityEstadosLaboratorioState, entityEstadosLaboratorioAdapter, initialState } from './estados-laboratorio.state';
import { entityEstadosLaboratorioLoadFailure, entityEstadosLaboratorioLoadRequest, entityEstadosLaboratorioLoadSuccess } from './estados-laboratorio.actions';


const reducer = createReducer(
  initialState,
  // load
  on(entityEstadosLaboratorioLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEstadosLaboratorioLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEstadosLaboratorioLoadSuccess, (state, { items }) =>
    entityEstadosLaboratorioAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
);

export function entityEstadosLaboratorioReducer(
  state: EntityEstadosLaboratorioState | undefined,
  action: Action
) {
  return reducer(state, action);
}
